<template>
  <div>
    <!-- Footer -->
    <footer class="page-footer font-small blue-grey lighten-5">
      <div style="background-color: #21d192">
        <div class="container">
          <!-- Grid row-->
          <div class="row py-4 d-flex align-items-center">
            <!-- Grid column -->
            <div
              class="col-md-6 col-lg-5 text-center text-md-left mb-4 mb-md-0"
            >
              <h6 class="mb-0">Get connected with us on social networks!</h6>
            </div>
            <!-- Grid column -->

            <!-- Grid column -->
            <div class="col-md-6 col-lg-7 text-center text-md-right">
              <!-- Facebook -->
              <a class="fb-ic">
                <i class="fab fa-facebook-f white-text mr-4"> </i>
              </a>
              <!-- Twitter -->
              <a class="tw-ic">
                <i class="fab fa-twitter white-text mr-4"> </i>
              </a>
              <!-- Google +-->
              <a class="gplus-ic">
                <i class="fab fa-google-plus-g white-text mr-4"> </i>
              </a>
              <!--Linkedin -->
              <a class="li-ic">
                <i class="fab fa-linkedin-in white-text mr-4"> </i>
              </a>
              <!--Instagram-->
              <a class="ins-ic">
                <i class="fab fa-instagram white-text"> </i>
              </a>
            </div>
            <!-- Grid column -->
          </div>
          <!-- Grid row-->
        </div>
      </div>

      <!-- Footer Links -->
      <div class="container text-center text-md-left mt-5">
        <!-- Grid row -->
        <div class="row mt-3 dark-grey-text">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-4 col-xl-3 mb-4">
            <!-- Content -->
            <h6 class="text-uppercase font-weight-bold">E-Kommerce</h6>
            <hr
              class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
              style="width: 60px"
            />
            <p>
              Here are the best product and service you can get, you want to know how you can
              participate for a better future ? Let us know
            </p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase font-weight-bold">Products</h6>
            <hr
              class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
              style="width: 60px"
            />
            <p>
              <a class="dark-grey-text" href="#!">Hardware</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Software</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Wear Ware</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Sports Ware</a>
            </p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase font-weight-bold">Useful links</h6>
            <hr
              class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
              style="width: 60px"
            />
            <p>
              <a class="dark-grey-text" href="#!">Your Account</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Become an Affiliate</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Shipping Rates</a>
            </p>
            <p>
              <a class="dark-grey-text" href="#!">Help</a>
            </p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
            <!-- Links -->
            <h6 class="text-uppercase font-weight-bold">Contact</h6>
            <hr
              class="teal accent-3 mb-4 mt-0 d-inline-block mx-auto"
              style="width: 60px"
            />
            <p><i class="fas fa-home mr-3"></i> Jakarta, JKT 140042, IDN</p>
            <p><i class="fas fa-envelope mr-3"></i> eternal.putra@gmail.com</p>
            <p><i class="fas fa-phone mr-3"></i> + 01 234 567 88</p>
            <p><i class="fas fa-print mr-3"></i> + 01 234 567 89</p>
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
      <!-- Footer Links -->

      <!-- Copyright -->
      <div class="footer-copyright text-center text-black-50 py-3">
        © 2020 Copyright:
        <a class="dark-grey-text" href="https://github.com/drfrostongithub/">
          DrFrost</a
        >
      </div>
      <!-- Copyright -->
    </footer>
    <!-- Footer -->
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
</style>
